module.exports = __webpack_public_path__ + "images/general-security.png";